<template>
    <div id="app">
        <main-header nowtab="bbs"></main-header>
        <main class="adjuster">
            <a-page-header
                style="border: 1px solid rgb(235, 237, 240)"
                :title="title"
                @back="back()"
            >
                <template slot="extra">
                    <a-button @click="triggerHostonly()">
                        {{ hostonly ? '浏览全部' : '只看楼主' }} 
                    </a-button>
                </template>
            </a-page-header>
            <a-pagination :current="Number(pagenow)" :total="total" class="top-pager"
                :defaultPageSize="10" @change="turnPage" :hideOnSinglePage="true"
            />
            <a-divider></a-divider>
            <a-list
                class="thread-list"
                item-layout="horizontal"
                :data-source="data"
            >
                <a-list-item slot="renderItem" slot-scope="item" :id="`p${ item.pid }`">
                    <a-list-item-meta class="item-meta">
                        <div slot="avatar" class="avatar-container">
                            <a-avatar :src="item.avatar" shape="square" :size="mobile ? 40 : 72"/>
                            <user-link :name="item.author" :id="item.authorid"/>
                        </div>
                        <Post slot="description" :item="item" @edit="openEditDialog"></Post>
                    </a-list-item-meta>
                </a-list-item>
            </a-list>
            <a-divider></a-divider>
            <a-pagination :current="Number(pagenow)" :total="total" 
                :defaultPageSize="10" @change="turnPage" :hideOnSinglePage="true"
            />
            <div v-show="hasLogin" id="editor">
                <wang-editor v-model="postData"></wang-editor>
                <a-button type="primary" id="reply" :loading="posting" @click="doReply">回复</a-button>
            </div>
            <a-result v-show="!hasLogin" title="尚未登录，请登录后回复">
                <template #icon></template>
                <template #extra>
                <a-button type="primary">
                    <a href="/login">登录</a>
                </a-button>
                </template>
            </a-result>
            <a-modal
                :title="`编辑帖子 - ${editpid}楼`"
                :visible="visible"
                :confirm-loading="editing"
                @ok="doEdit"
                @cancel="() => visible = false"
                width="95%"
            >
                <wang-editor ref="edit" v-model="editData"></wang-editor>
            </a-modal>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import UserLink from '@/components/UserLink.vue';
import Footer from '@/components/Footer'
import WangEditor from '@/components/WangEditor'
import Post from './Post.vue'
import axios from 'axios';
import { mapState } from 'vuex';
import { createFormData, getSSRdata } from '../../utils/utils';

const handle = window.matchMedia('(max-width: 599px)');

export default {
    data: () => ({
        data: [],
        bid: 0,
        tid: 0,
        pagenow: 0,
        total: 0,
        title: '',
        hostonly: false,
        postData: "",
        posting: false,
        visible: false,
        editData: "",
        editing: false,
        editpid: -1,
        mobile: handle.matches,
    }),
    computed: {
        ...mapState({ hasLogin: 'hasLogin' }),
    },
    async created() {
        handle.onchange = (e) => this.mobile = e.matches;
        const {
            thread: { bid, tid, title }, page, hostonly, list, total
        } = getSSRdata("thread");
        this.bid = bid;
        this.tid = tid;
        this.pagenow = page;
        this.hostonly = hostonly;
        this.data = list;
        this.total = total;
        this.title = title;
        document.title = title + " - H5魔塔广场";
    },
    methods: {
        back() {
            window.location.pathname = "/bbs";
        },
        turnPage(page) {
            if (this.hostonly) {
                window.location.search = `?bid=${this.bid}&tid=${this.tid}&p=${page}&hostonly=1`;
            } else {
                window.location.search = `?bid=${this.bid}&tid=${this.tid}&p=${page}`;
            }
        },
        triggerHostonly() {
            if (this.hostonly) {
                window.location.search = `?bid=${this.bid}&tid=${this.tid}&p=${this.pagenow}`;
            } else {
                window.location.search = `?bid=${this.bid}&tid=${this.tid}&p=${this.pagenow}&hostonly=1`;
            }
        },
        doReply() {
            this.posting = true;
            let content = this.postData;
            content = content.replace(/&/g, "&amp;");
            if (content == "" || content == "<br>") {
                alert("请填写回复内容！");
                return;
            }

            axios.post("/backend/bbs/post.php", createFormData({
                bid: this.bid,
                tid: this.tid,
                text: content,
                title: `Re: ${this.title}`
            })).then(({ data }) => {
                this.posting = false;
                if (data.code == 0) {
                    this.$message.success('发布成功');
                    window.location.reload();
                } else
                    alert("错误：" + data.msg);
            });
        },
        openEditDialog({ pid, text }) {
            this.editpid = pid;
            if (this.$refs.edit) {
                this.$refs.edit.setValue(text);
            } else {
                this.editData = text;
            }
            this.visible = true;
        },
        async doEdit() {
            const { data } = await axios.post("/backend/bbs/edit.php", createFormData({
                bid: this.bid,
                tid: this.tid,
                pid: this.editpid,
                text: this.editData,
                title: this.editpid == 1 ? this.title : `Re: ${this.title}`
            }));
            this.posting = false;
            if (data.code == 0) {
                this.visible = false;
                this.$message.success('修改成功');
                window.location.reload();
            } else
                alert("错误：" + data.msg);
        }
    },
    components: {
        MainHeader, Footer, UserLink, Post, WangEditor,
    }
}
</script>

<style lang="less">
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
.adjuster {
    margin: 20px auto;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
}
.ant-list-item-meta {
    @media screen and (max-width: 599px) {
        flex-direction: column;
        margin: 0 5px;
        .ant-list-item-meta-avatar {
            width: 100%;
        }
    }
}
.avatar-container {
    display: flex;
    @media screen and (min-width: 600px) {
        flex-direction: column;
        width: 96px;
    }
    @media screen and (max-width: 599px) {
        width: 100%;
        .user-link {
            margin-left: 10px;
        }
    }
    align-items: center;
    margin-bottom: 5px;
}
#editor {
    margin-top: 20px;
    text-align: left;
}
#reply {
    margin-left: 15px;
}
.ant-pagination.top-pager {
    margin-top: 10px;
    margin-bottom: -10px;
}
</style>

